import { render, staticRenderFns } from "./NewsEvent.vue?vue&type=template&id=05dfcd4e&scoped=true&"
import script from "./NewsEvent.vue?vue&type=script&lang=js&"
export * from "./NewsEvent.vue?vue&type=script&lang=js&"
import style0 from "./NewsEvent.vue?vue&type=style&index=0&id=05dfcd4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dfcd4e",
  null
  
)

export default component.exports